import type { IconNode } from '../types';

/**
 * @name feather
 * @description Lucide SVG icon node.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNMTQuMDg2IDE4LjQxMkEyIDIgMCAwMTEyLjY3IDE5SDV2LTcuNjcyYTIgMiAwIDAxLjU4Ni0xLjQxNEwxMS43NSAzLjc1YTYgNiAwIDExOC40OSA4LjQ5eiIgLz4KICA8cGF0aCBkPSJNMTYgOCAyIDIyIiAvPgogIDxwYXRoIGQ9Ik0xNy40ODggMTVIOSIgLz4KPC9zdmc+Cg==) - https://lucide.dev/icons/feather
 * @see https://lucide.dev/guide/packages/lucide - Documentation
 *
 * @returns {Array}
 *
 */
const Feather: IconNode = [
  [
    'path',
    {
      d: 'M14.086 18.412A2 2 0 0112.67 19H5v-7.672a2 2 0 01.586-1.414L11.75 3.75a6 6 0 118.49 8.49z',
    },
  ],
  ['path', { d: 'M16 8 2 22' }],
  ['path', { d: 'M17.488 15H9' }],
];

export default Feather;
